import { useContext, useEffect, useState } from "react"
import { VisitantesContext } from "../../../../Providers/VisitantesContext/VisitantesContext"
import { WebSocketContext } from "../../../../Providers/WebSocket/WebSocketContext"
import { CircularProgress, Grid, Typography } from "@mui/material"
import CardAutorizados from "./CardAutorizados"
import OneButton from "../../../../Components/OneButton/OneButton"
import ModalAutorizados from "./ModalAutorizados"

const Autorizados = () => {
    const [autorizados, setAutorizados] = useState([])
    const { visitanteInfo, selecionarAutorizacao } = useContext(VisitantesContext)
    const { addRoute } = useContext(WebSocketContext)
    const [loading, setLoading] = useState(true)
    const [openModal, setOpenModal] = useState(false)
    const [idAutorizacao, setIdAutorizacao] = useState(null)
    addRoute('buscarAutorizadosPorVisitante', (msg) => {
        setAutorizados(msg.data.autorizados)
        setLoading(false)
    })

    useEffect(() => {
        if (idAutorizacao) {
            setOpenModal(true)
        }
    }, [idAutorizacao])

    return (
        <Grid sx={{
            width: '100%',
            height: '90%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
            {openModal &&
                <ModalAutorizados
                    openModal={openModal}
                    id={idAutorizacao}
                    setOpenModal={setOpenModal}
                    setIdAutorizacao={setIdAutorizacao}
                    cd_acesso_visitante={visitanteInfo.CD_ACESSO}
                />
            }
            <Grid sx={{
                width: '100%',
                height: '10%',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '10px',
                marginBottom: '10px'
            }}>
                <OneButton variant="contained" color="one_primary" backgroundColor="#0FBB00"
                    newSx={{ fontWeight: 'bold', width: '10%' }} onClick={() => {
                        setIdAutorizacao(null)
                        setOpenModal(true)
                    }}>Adicionar</OneButton>
                <Typography sx={{ fontSize: '20px', fontWeight: 'bold', height: '100%' }}>Autorizações</Typography>
                <div style={{ width: '10%' }}></div>
            </Grid>
            {loading && autorizados.length === 0 && !visitanteInfo
                ? <CircularProgress />
                : (
                    <Grid container gap={1} sx={{
                        width: '99%',
                        height: '100%',
                        overflow: 'auto',
                        alignContent: 'flex-start',
                        justifyContent: 'center'
                    }}>
                        {autorizados.length > 0
                            ? autorizados.map((autorizado) => (
                                <CardAutorizados key={`key-${autorizado.id}`} nome={autorizado.morador}
                                    imovel={autorizado.imovel}
                                    dt_inicial={autorizado.dt_inicial} dt_final={autorizado.dt_final}
                                    id={autorizado.id}
                                    adicionarAutorizacao={() => selecionarAutorizacao(autorizado)}
                                    editarAutorizacao={() => { setIdAutorizacao(autorizado.id) }} />
                            ))
                            : <Typography sx={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>
                                Nenhuma autorização encontrada para este visitante
                            </Typography>
                        }
                    </Grid>
                )}
        </Grid>
    )
}

export default Autorizados
